export default 'https://tme.understood.org/assets/particles_music.39460bd2.glb'